import React, { useEffect, useState, useContext, Fragment } from "react";
import SharedDataContext from "../../../../_helper/SharedData";
import { showAlert } from "../../../../Services/Shared.service";
import { Breadcrumbs } from "../../../../AbstractElements";
import { Row, Col, Card, CardBody, Container } from "reactstrap";
import {
  getPackagesListCorp,
  getPackage,
} from "../../../../Services/Packages.service";
import PackageInput from "../../../Packages/PackageInput";
import CustomizerContext from "../../../../_helper/Customizer";
import PackagesTable from "../../../Packages/PackagesTable";
import editBlackIcon from "../../../../assets/images/tarrifManagement/EditBlack.svg";
import {
  Box,
  Paper,
  styled,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Skeleton,
} from "@mui/material";
import { useNavigate } from "react-router";
import CreateEditPackageDrawerForm from "../../../FormsTariff/CreateEditPackageDrawerForm";
import EditPackageRateForm from "../../../FormsTariff/EditPackageRateForm";

function PackagesTableView(props) {
  const { cityData, globalCityField, setShowApiLoader, packageTable } =
    useContext(SharedDataContext);
  const [tableData, setTableData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [pagination, setPagination] = useState(0);
  const [paginationTotalRows, setPaginationTotalRows] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [editId, setEditId] = useState("");
  const [searchData, setSearchData] = useState("");
  const [filterType, setFilterType] = useState("");
  const [filterData, setFilterData] = useState([]);
  const { mix_background_layout } = useContext(CustomizerContext);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(4);
  const [isEditPackageDrawerOpen, setIsEditPackageDrawerOpen] = useState({
    drawerState: false,
    selectedPackageId: "",
  });

  const navigate = useNavigate();

  const onChangePage = (page) => {
    console.log("page", page);
    setPagination(page - 1);
  };

  const onChangeRowsPerPage = (currentRowsPerPage) => {
    setRowsPerPage(currentRowsPerPage);
  };

  const disableLoaders = () => {
    setLoader(false);
    // setShowApiLoader(false);
  };

  useEffect(() => {
    fetchTableData();
  }, [props.corpId, pagination, rowsPerPage]);
  useEffect(() => {
    fetchTableData()
  }, [packageTable])

  const fetchTableData = () => {
    let obj = {
      corporateId: props.corpId,
    };
    setLoader(true);
    getPackagesListCorp(obj)
      .then((result) => {
        // setPaginationTotalRows(result.data);
        setTableData(result.data.list);
        setPaginationTotalRows(tableData.length)
        disableLoaders();
      })
      .catch((err) => {
        disableLoaders();
        showAlert(
          "error",
          err.response?.data?.message
            ? err.response.data.message
            : "Something went wrong"
        );
      });
  };



  const onEditClick = (obj) => {
    setIsOpen(!isOpen);
    setEditId(obj.id);
  };

  const toggleModal = () => {
    fetchTableData();
    setEditId("");
    setIsOpen(!isOpen);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Fragment>
      <Row>
        {/* <PackagesTable
                fetchTableData={fetchTableData}
                tableData={tableData}
                setShowApiLoader={setLoader}
                onChangePage={onChangePage}
                paginationPerPage={rowsPerPage}
                paginationTotalRows={paginationTotalRows}
                onChangeRowsPerPage={onChangeRowsPerPage}
                onEditClick={onEditClick}
                loader={loader}
              /> */}
        <Box sx={{ marginTop: "20px" }}>
          {tableData.length == 0 ? (
            <Box
              sx={{
                width: "100%",
                backgroundColor: "white",
                minHeight: "200px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "6px",
              }}
            >
              <Typography sx={{ color: "black" }}>
                No Packages Available
              </Typography>
            </Box>
          ) : (
            <>
              <TableContainer
                component={Paper}
                aria-label="sticky table"
                sx={{
                  // height: "19vw",
                  maxHeight: "19vw",
                  scrollbarWidth: "none", // Firefox
                  "&::-webkit-scrollbar": {
                    display: "none", // Chrome, Safari, Edge
                  },
                  borderRadius: "6px",
                  borderWidth: "1px",
                  borderColor: "rgba(217, 217, 217, 1)",
                }}
              >
                <Table stickyHeader>
                  <TableHead>
                    <TableRow
                      sx={{
                        "& th": {
                          color: "#626262",
                          fontWeight: "700",
                          fontSize: "1.11vw",
                          height: "3.89vw",
                          maxHeight: "5vw",
                          paddingX: 0,
                          paddingY: "12px",
                          backgroundColor: "#E1F4E4",
                        },
                      }}
                    >
                      <TableCell sx={{ maxWidth: "9.87vw" }}>
                        <Box
                          sx={{
                            textAlign: "left",
                            paddingX: "10px",
                          }}
                        >
                          Package Name
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ textAlign: "left", paddingX: "10px" }}>
                          Service City
                        </Box>
                      </TableCell>
                      {/* <TableCell align="left">Service City</TableCell> */}
                      <TableCell align="left">Initial Distance(Km)</TableCell>
                      <TableCell align="left">
                        Initial Distance Charge
                      </TableCell>
                      <TableCell align="left">Per Km Charge</TableCell>
                      <TableCell align="left">Available On</TableCell>
                      <TableCell align="left">Availability</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {loader
                      ? // Skeleton loader rows
                        [...Array(rowsPerPage)].map((_, index) => (
                          <TableRow key={index}>
                            <TableCell sx={{ maxWidth: "9.87vw" }}>
                              <Skeleton
                                variant="text"
                                width="80%"
                                height="1.5vw"
                              />
                            </TableCell>
                            <TableCell>
                              <Skeleton
                                variant="text"
                                width="70%"
                                height="1.5vw"
                              />
                            </TableCell>
                            <TableCell>
                              <Skeleton
                                variant="text"
                                width="60%"
                                height="1.5vw"
                              />
                            </TableCell>
                            <TableCell>
                              <Skeleton
                                variant="text"
                                width="70%"
                                height="1.5vw"
                              />
                            </TableCell>
                            <TableCell>
                              <Skeleton
                                variant="text"
                                width="60%"
                                height="1.5vw"
                              />
                            </TableCell>
                            <TableCell>
                              <Skeleton
                                variant="text"
                                width="60%"
                                height="1.5vw"
                              />
                            </TableCell>
                            <TableCell>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                gap={1}
                              >
                                <Skeleton
                                  variant="rounded"
                                  width="42px"
                                  height="26px"
                                />
                                <Skeleton
                                  variant="text"
                                  width="30px"
                                  height="1.5vw"
                                />
                                <Skeleton
                                  variant="circular"
                                  width="1.75vw"
                                  height="1.61vw"
                                />
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))
                      : tableData
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((singlePackageData) => (
                            <TableRow
                              key={singlePackageData.id}
                              sx={{
                                "&:hover": {
                                  cursor: "pointer",
                                  backgroundColor: "#EBEBEB",
                                },
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                                "& td": {
                                  fontSize: "1.11vw",
                                  paddingX: "10px",
                                  borderBottom: "none",
                                },
                              }}
                              // onClick={() =>
                              //   navigate(
                              //     `${process.env.PUBLIC_URL}/tariff_master/view/packages/${singlePackageData.id}`
                              //   )
                              // }
                            >
                              <TableCell sx={{ maxWidth: "9.87vw" }}>
                                <Box
                                  sx={{
                                    textAlign: "left",
                                    fontSize: "1vw",
                                    color: "#39B54A",
                                    fontWeight: "600",
                                    mx: "8px",
                                  }}
                                  onClick={() =>
                                    navigate(
                                      `${process.env.PUBLIC_URL}/tariff_master/view/packages/${singlePackageData.id}`
                                    )
                                  }
                                >
                                  {singlePackageData.name}
                                </Box>
                              </TableCell>
                              <TableCell>
                                <Box
                                  sx={{
                                    // textAlign: "left",
                                    // fontSize: "1vw",
                                    // color: "#39B54A",
                                    // fontWeight: "600",
                                    // mx: "8px",
                                    textAlign: "left",
                                    color: "black",
                                    fontWeight: "bold",
                                    fontSize: "0.97vw",
                                    padding: "12px 8px",
                                  }}
                                >
                                  {singlePackageData.serviceCityName ?? "-"}
                                </Box>
                              </TableCell>
                              <TableCell align="left">
                                <Box
                                  sx={{
                                    textAlign: "left",
                                    fontSize: "1vw",
                                    color: "#313131",
                                  }}
                                >
                                  {singlePackageData.initialDistanceKm ?? "-"}
                                </Box>
                              </TableCell>

                              <TableCell align="left">
                                <Box
                                  sx={{
                                    textAlign: "left",
                                    color: "black",
                                    fontWeight: "bold",
                                    fontSize: "0.97vw",
                                    padding: "12px 8px",
                                  }}
                                >
                                  {singlePackageData.initialDistanceCharge ??
                                    "-"}
                                </Box>
                              </TableCell>

                              <TableCell align="left">
                                <Box
                                  sx={{
                                    textAlign: "left",
                                    fontSize: "0.97vw",
                                    color: "#313131",
                                    fontWeight: "400",
                                  }}
                                >
                                  {singlePackageData.perKmCharge
                                    ? singlePackageData.perKmCharge
                                    : "-"}
                                </Box>
                              </TableCell>

                              <TableCell align="center">
                                <Box
                                  sx={{
                                    textAlign: "left",
                                    fontSize: "1vw",
                                    color: "#313131",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {singlePackageData.isKiosk
                                    ? "Kiosk"
                                    : "TMS"}
                                </Box>
                              </TableCell>

                              <TableCell align="center">
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="space-between"
                                  gap={1}
                                  sx={{}}
                                >
                                  {singlePackageData.isActive ? (
                                    <>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          backgroundColor: "#E3F5E1",
                                          width: "6vw",
                                          height: "2.01vw",
                                          justifyContent: "space-evenly",
                                          alignItems: "center",
                                          borderRadius: "6px",
                                          padding: "6px",
                                          border:
                                            "2px solid rgba(116, 206, 106, 1)",
                                          // height: "2.01vw",
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            width: "0.56vw",
                                            height: "0.56vw",
                                            background:
                                              "rgba(116, 206, 106, 1)",
                                            borderRadius: "50%",
                                          }}
                                        />
                                        <Typography sx={{ fontSize: "0.97vw" }}>
                                          Yes
                                        </Typography>
                                      </Box>
                                    </>
                                  ) : (
                                    <>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-around",
                                          width: "6vw",
                                          height: "2.01vw",
                                          borderRadius: "6px",
                                          padding: "6px",
                                          backgroundColor: "#ffe5e5", // light red
                                          border: "2px solid #cc0000", // darker red border
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            width: "0.56vw",
                                            height: "0.56vw",
                                            backgroundColor: "#cc0000",
                                            borderRadius: "50%",
                                          }}
                                        />
                                        <Typography
                                          sx={{
                                            fontSize: "0.97vw",
                                            color: "#cc0000",
                                          }}
                                        >
                                          No
                                        </Typography>
                                      </Box>
                                    </>
                                  )}
                                  <img
                                    src={editBlackIcon}
                                    alt="edit"
                                    style={{
                                      width: "1.75vw",
                                      height: "1.61vw",
                                    }}
                                    onClick={() =>
                                      setIsEditPackageDrawerOpen((prev) => ({
                                        ...prev,
                                        drawerState: true,
                                        selectedPackageId: singlePackageData.id,
                                      }))
                                    }
                                  />
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                component="div"
                count={tableData.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[4, 10, 25, 50]}
                sx={{
                  "& .MuiTablePagination-toolbar": {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    width: "100%",
                    gap: 2,
                    textAlign: "center",
                    overflowX: "hidden",
                  },
                  // dropdown style
                  "& .MuiTablePagination-select": {
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    borderRadius: "6px",
                    paddingX: "8px",
                    paddingY: "4px",
                    border: "1px solid #D9D9D9",
                  },

                  // arrows bigger and green
                  "& .MuiTablePagination-actions button": {
                    color: "rgba(112, 112, 112, 1)",
                    transform: "scale(1.3)",
                  },

                  "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                    {
                      color: "rgba(98, 98, 98, 1)",
                      fontSize: "0.97vw",
                      textAlign: "center",
                      m: "auto",
                      letterSpacing: "0.02vw",
                    },
                }}
              />
            </>
          )}
        </Box>
      </Row>
      {/* <PackageInput
        cityData={cityData}
        editId={editId}
        isOpen={isOpen}
        toggleModal={toggleModal}
      /> */}
      <CreateEditPackageDrawerForm
        title="Edit Packages"
        isOpen={isEditPackageDrawerOpen.drawerState}
        setIsOpen={() =>
          setIsEditPackageDrawerOpen((prev) => ({
            ...prev,
            drawerState: false,
          }))
        }
        editId={isEditPackageDrawerOpen.selectedPackageId}
        fetchTableData={fetchTableData}
      />
    </Fragment>
  );
}

export default PackagesTableView;
